import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	automationGroup: {
		id: 'spa-apps-sidebar-global-settings-system.menu.automation.automation-group',
		defaultMessage: 'Automation',
		description: 'Navigation group heading for automation settings items',
	},
	globalAutomation: {
		id: 'spa-apps-sidebar-global-settings-system.menu.automation.global-automation',
		defaultMessage: 'Global automation',
		description: 'Navigation item which links to a global automation page',
	},
});
